import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

export default function OffersPopup() {
  const [show, setShow] = useState(false);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    const shown = sessionStorage.getItem('apex_offer_popup_shown');
    if (!shown) {
      api.get('/offers').then(({ data }) => {
        if (data.offers?.length) {
          setOffers(data.offers.slice(0, 3));
          setShow(true);
          sessionStorage.setItem('apex_offer_popup_shown', '1');
        }
      }).catch(() => {});
    }
  }, []);

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={() => setShow(false)}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600, padding: 0, overflow: 'hidden' }}>
        <div style={{ background: 'var(--gradient-primary)', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 20, color: '#fff', margin: 0 }}>🔥 NEW OFFERS TODAY!</h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 14, margin: '4px 0 0' }}>Don't miss these exclusive deals</p>
          </div>
          <button onClick={() => setShow(false)} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', width: 32, height: 32, borderRadius: '50%', cursor: 'pointer', fontSize: 16 }}>✕</button>
        </div>
        <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
          {offers.map(offer => (
            <div key={offer._id} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 10, padding: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 4 }}>{offer.title}</div>
                <div style={{ color: 'var(--text-secondary)', fontSize: 13 }}>{offer.description?.substring(0, 80)}...</div>
                {offer.code && <div style={{ marginTop: 6, display: 'inline-block', background: 'var(--bg-card)', border: '1px dashed var(--accent-cyan)', borderRadius: 6, padding: '2px 10px', fontSize: 13, color: 'var(--accent-cyan)', fontWeight: 700 }}>CODE: {offer.code}</div>}
              </div>
              {offer.discount && <div style={{ background: 'var(--gradient-gold)', padding: '8px 14px', borderRadius: 8, fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: 18, color: '#fff', whiteSpace: 'nowrap' }}>{offer.discount}</div>}
            </div>
          ))}
          <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
            <a href="/offers" style={{ flex: 1, textAlign: 'center' }} className="btn btn-primary" onClick={() => setShow(false)}>View All Offers</a>
            <button className="btn btn-secondary" onClick={() => setShow(false)} style={{ flex: 1 }}>Maybe Later</button>
          </div>
        </div>
      </div>
    </div>
  );
}
